"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
class KeyringEncryptor {
    static async encrypt(keyringSerialization, encryptionKey) {
        if (encryptionKey.length !== 32) {
            throw new Error("32 byte encryption key expected");
        }
        // Format version 1 specs:
        // - encode keyring serialization as UTF-8
        // - use Xchacha20poly1305Ietf with 24 byte nonce
        // - prepend nonce to ciphertext
        const formatVersion = new encoding_1.Uint32(1);
        const keyringPlaintext = encoding_1.toUtf8(keyringSerialization);
        const keyringNonce = await KeyringEncryptor.makeXchacha20poly1305IetfNonce();
        const keyringCiphertext = await crypto_1.Xchacha20poly1305Ietf.encrypt(keyringPlaintext, encryptionKey, keyringNonce);
        const out = new Uint8Array([...formatVersion.toBytesBigEndian(), ...keyringNonce, ...keyringCiphertext]);
        return out;
    }
    static async decrypt(encrypted, encryptionKey) {
        const formatVersionLength = 4;
        const formatVersion = encoding_1.Uint32.fromBigEndianBytes(encrypted.slice(0, formatVersionLength));
        switch (formatVersion.toNumber()) {
            case 1: {
                const nonceLength = 24;
                const nonce = encrypted.slice(formatVersionLength, formatVersionLength + nonceLength);
                const ciphertext = encrypted.slice(formatVersionLength + nonceLength);
                const decrypted = await crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext, encryptionKey, nonce);
                return encoding_1.fromUtf8(decrypted);
            }
            default:
                throw new Error(`Unsupported format version: ${formatVersion.toNumber()}`);
        }
    }
    static async makeXchacha20poly1305IetfNonce() {
        return crypto_1.Random.getBytes(24);
    }
}
exports.KeyringEncryptor = KeyringEncryptor;
//# sourceMappingURL=keyringencryptor.js.map